@if (countOnly) {
  <div>
    <span>
      {{ playerLicenseService.getAvailableLicenseCountString() }}
    </span>
  </div>
} @else {
  <div
    class="tw-flex tw-gap-[8px] tw-pb-10 md:!tw-pb-0 tw-w-full tw-max-w-full tw-overflow-x-auto"
  >
    @for (item of items(); track $index) {
      <div class="count-item">
        <div class="count-item__body">
          <rv-badge
            shape="icon"
            [color]="item.color"
            [icon]="item.icon"
            [matTooltip]="item.tooltip"
            matTooltipClass="rv-badge-tooltip"
          />
          <div class="count-item__copy">
            <span class="count-item__title">{{ item.text }}</span>
            <span class="count-item__subtext">{{ item.subtext }}</span>
          </div>
        </div>
      </div>
    }
  </div>
}
